<template>
        <div v-if="articleList.length > 0">
            <pb-carousel>
                <router-link class="card-deck category-card-deck my-3" :key="index"
                             v-for="(article,index) in articleList"
                             :to="{name: 'ar', params: {articleId: article.id, categoryId: 1500, variantId: article.colorId, cardId: article.cardId}}">
                    <pb-card class="article-card mx-3"
                             :img-src="article.thumbnail">
                        <template slot="content">
                            <span class="d-block article-title">{{article.description}}</span>
                        </template>
                    </pb-card>
                </router-link>
            </pb-carousel>
        </div>
</template>

<script>
    export default {
        name: 'pb-article-slider',
        props: {
            articleList: {
                type: Array
            },
            id: {
                type: String
            },
            articleAmount: {
                type: Number
            }
        }
    }
</script>

<style lang="scss" >

    @import "~@shared/_assets/scss/constants";

    .article-card {
        width: 275px;
    }


</style>